<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} {{aLang.itcc_title}}</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} {{aLang.itcc_title}}</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} {{aLang.itcc_title}}</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row v-if="mData.dataForm.reason">
            <b-col md="12">
              <el-alert
                :title="mData.dataForm.reason"
                type="error"
                center
                show-icon
                :closable="false"
              ></el-alert>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <el-form-item :label="aLang.itcc_surname_buffer" prop="last_name">
                <el-input
                  type="text"
                  v-model="mData.dataForm.last_name"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item :label="aLang.itcc_name" prop="first_name">
                <el-input
                  type="text"
                  v-model="mData.dataForm.first_name"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item :label="aLang.itcc_bod" prop="dob">
                <el-input
                  type="text"
                  v-model="mData.dataForm.dob"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item :label="aLang.itcc_gender" prop="gioi_tinh">
                <el-select
                  v-model="mData.dataForm.gioi_tinh"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listGioiTinh"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <el-form-item :label="aLang.itcc_number_of_papers" prop="cmnd_number">
                <el-input
                  type="text"
                  v-model="mData.dataForm.cmnd_number"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item :label="aLang.itcc_health_insurance_card_number" prop="bhyt_number">
                <el-input
                  type="text"
                  v-model="mData.dataForm.bhyt_number"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item :label="aLang.itcc_passport_number" prop="passport_no">
                <el-input
                  type="text"
                  v-model="mData.dataForm.passport_no"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item :label="aLang.itcc_phone" prop="mobile">
                <el-input
                  type="text"
                  v-model="mData.dataForm.mobile"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <el-form-item :label="aLang.itcc_nationality" prop="nationality_name">
                <el-input
                  type="text"
                  v-model="mData.dataForm.nationality_name"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item :label="aLang.itcc_country_code" prop="nationality_code">
                <el-input
                  type="text"
                  v-model="mData.dataForm.nationality_code"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <!-- <b-col md="3">
              <el-form-item label="Số hộ chiếu" prop="passport_no">
                <el-input
                  type="text"
                  v-model="mData.dataForm.passport_no"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Số điện thoại" prop="mobile">
                <el-input
                  type="text"
                  v-model="mData.dataForm.mobile"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>-->
          </b-row>
          <b-row>
            <b-col md="6">
              <el-form-item :label="aLang.itcc_tourist_card_registration_code" prop="register_code">
                <el-input
                  type="text"
                  v-model="mData.dataForm.register_code"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item :label="aLang.itcc_card_number" prop="card_code">
                <el-input
                  type="text"
                  v-model="mData.dataForm.card_code"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <!-- <b-col md="3">
              <el-form-item label="Số hộ chiếu" prop="passport_no">
                <el-input
                  type="text"
                  v-model="mData.dataForm.passport_no"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Số điện thoại" prop="mobile">
                <el-input
                  type="text"
                  v-model="mData.dataForm.mobile"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>-->
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  {{aLang.itcc_guardians}}
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseNguoiGiamHo
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseNguoiGiamHo" visible>
                  <b-row>
                    <b-col md="3">
                      <el-form-item :label="aLang.itcc_surname_buffer" prop="guardian.last_name">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.guardian.last_name"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item :label="aLang.itcc_name" prop="guardian.first_name">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.guardian.first_name"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item :label="aLang.itcc_bod" prop="guardian.dob">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.guardian.dob"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item :label="aLang.itcc_gender" prop="guardian.gioi_tinh">
                        <el-select
                          v-model="mData.dataForm.guardian.gioi_tinh"
                          :placeholder="aLang.c_select"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listGioiTinh"
                            :key="item.id"
                            :label="item.text"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3">
                      <el-form-item :label="aLang.itcc_number_of_papers" prop="guardian.cmnd_number">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.guardian.cmnd_number"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item :label="aLang.itcc_health_insurance_card_number" prop="guardian.bhyt_number">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.guardian.bhyt_number"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item :label="aLang.itcc_passport_number" prop="guardian.passport_no">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.guardian.passport_no"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item :label="aLang.itcc_phone" prop="guardian.mobile">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.guardian.mobile"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="3">
                      <el-form-item :label="aLang.itcc_nationality" prop="guardian.nationality_name">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.guardian.nationality_name"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item :label="aLang.itcc_country_code" prop="guardian.nationality_code">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.guardian.nationality_code"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <!-- <b-col md="3">
                      <el-form-item label="Số hộ chiếu" prop="guardian.passport_no">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.guardian.passport_no"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Số điện thoại" prop="guardian.mobile">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.guardian.mobile"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>-->
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import MsKhachDuLichModel from "./MsKhachDuLichModel";
import MsKhachDuLichApi from "../../../moduleApi/MsKhachDuLichApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "MsKhachDuLich",
        dataDefault: {
          roles: DataService.rolesInForm,
          listGioiTinh: DataService.gioiTinh
        },
        dataForm: MethodService.copyObject(MsKhachDuLichModel.dataForm),
        validForm: MsKhachDuLichModel.validForm,
        dialog: {}
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          if (type == "create") {
            await MsKhachDuLichApi.create(this.mData.dataForm);
            this.fn_resetForm();
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await MsKhachDuLichApi.update(this.mData.dataForm);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await MsKhachDuLichApi.findById(id);
      // debugger;
      if (res.result) {
        let resData = MethodService.checkDifferentObject(
          MsKhachDuLichModel.dataForm,
          res.result
        );
        if (resData.dob) {
          resData.dob = this.fn_formatterDobDate(resData.dob);
        } else {
          resData.dob = null;
        }
        if (resData.guardian && resData.guardian.dob) {
          resData.guardian.dob = this.fn_formatterDobDate(resData.guardian.dob);
        } else {
          resData.guardian.dob = null;
        }
        this.mData.dataForm = resData;
      }
    },
    async fn_initDataDefault() {},

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterDobDate(cellValue) {
      let ngay = cellValue.toString().substring(6, 8);
      let thang = cellValue.toString().substring(4, 6);
      let nam = cellValue.toString().substring(0, 4);
      return ngay + "/" + thang + "/" + nam;
      // return MethodService.formatDate(ngay, "datetime");
    }
  },
  created: function() {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>